<template>
    <div>
    <v-card
        class="mx-auto mt-4"
        max-width="95%"
        elevation="2"
    >
    <v-toolbar
        color="#37474F"
        dark
    >
    <v-toolbar-title>쿠폰을 발행합니다.</v-toolbar-title>
    <v-spacer></v-spacer>
    <v-tooltip top>
        <template v-slot:activator="{ on, attrs }">
        <v-btn
            color="blue-grey lighten-2"
            small
            fab
            v-bind="attrs"
            v-on="on"
        >
            <v-icon 
            color= "blue-grey darken-1"
            >mdi-help</v-icon>
        </v-btn>
    </template>
    <span>싱글 타입 쿠폰발행에는 다소 시간이 소요됩니다. 한번에 최대 20만개 까지만 만들어주세요. 그 이상이 필요한경우 저스틴에게 문의!</span>
    </v-tooltip>
    </v-toolbar>

    
    <v-list>
        <v-list-item>
            <span class="label-col"><v-card-title class="font-weight-bold">쿠폰 타입</v-card-title></span>
            <v-select
            v-model="selectedCouponType"
                :items="couponType"
                item-text="name"
                item-value="value"
                label="타입설정"
                @change="onCouponTypeChange"
                outlined
                hide-details
            ></v-select>
        </v-list-item>       
        <v-divider/>         
        <v-list-item v-if="selectedCouponType == 'single'">
            <span class="label-col"><v-card-title class="font-weight-bold">발행갯수</v-card-title></span>
            <v-text-field            
                label="몇개의 쿠폰을 발행하실 건가요?. 기본 1개 최대 50만개"
                v-model="couponCount"
                type="number"
                value=""            
            ></v-text-field>         
        </v-list-item>
        <v-divider v-if="selectedCouponType != 'single'">
        </v-divider> 
        <v-list-item v-if="selectedCouponType != 'single'">
            <span class="label-col"><v-card-title class="font-weight-bold">직접입력</v-card-title></span>
            <v-switch
              v-model="customSwitch"
              label="직접입력"
              color="red darken-3"
              hide-details
              class="mr-5 mb-5"
              @change="onCustomSwitchChange"
            ></v-switch>
            <v-text-field
                v-if="customSwitch"            
                label="3글자 이상을 직접 입력해주세요"
                v-model="customCouponId.id"
                dense
                hide-details
                :disabled ="doubleCheck?false:true"
            ></v-text-field>
            <v-btn
                v-if="customSwitch"
                class="ml-5"
                color="blue"
                :disabled ="doubleCheck?customCouponId.id.length >= 3?false:true:true"
                @click="clickCheckDoubleBtn"
            >
                {{ doubleCheck?'중복확인':'중복확인됨'}}
            </v-btn>
            <v-btn
                :disabled ="doubleCheck?true:false"
                v-if="customSwitch"
                class="ml-5"
                color="red"
                @click="clearDoubleCheck"
            >
                취소
            </v-btn>
            <v-spacer></v-spacer>
        </v-list-item>
        <v-divider/>    
        <v-list-item>
            <span class="label-col"><v-card-title class="font-weight-bold">쿠폰 설명</v-card-title></span>
            <v-text-field
                label="쿠폰에 대한 가벼운 메모를 남기세요."
                v-model="couponMessage"
                value=""            
            ></v-text-field> 
        </v-list-item>   
        
        <!-- 수령 가능 기간 -->
        <v-divider/>     
        <v-list-item>
        <span class="label-col"><v-card-title class="font-weight-bold">종료 날짜</v-card-title></span>        
        <!-- ====================== 시작 날짜를 지정합니다 ====================== -->
        <!-- <v-col cols="12" lg="6"> -->
        <span style="width:200px">
        <v-menu
            v-model="date_picker_2"
            :close-on-content-click="false"
            max-width="290"
        >
        <template v-slot:activator="{ on, attrs }">
            <v-text-field
                :value="computedDateFormattedMomentjs_end"
                clearable
                label="종료날짜 (디폴트는 석달 뒤)"
                readonly
                v-bind="attrs"
                v-on="on"
                @click:clear="date_end = null"
            ></v-text-field>
        </template>
        <v-date-picker
            v-model="date_end"
            @change="date_picker_2 = false"
        ></v-date-picker>
        </v-menu>
        </span>
        </v-list-item>



       <!-- 지급 상품  -->
        <v-divider/>
        <template v-for="(item, index) in selected_itemList">
        <v-list-item :key="index+1" class="mt-3">
        <span class="label-col"><v-card-title class="font-weight-bold">아이템 {{index + 1}}</v-card-title></span>
        <span style="width:120px" >        
        <v-select
        v-model="selected_itemList[index]"
            :items="current_reward_list"
            item-text="name"
            item-value="key"
            label="타입설정"
            @change="Refresh_ItemInfo"
            outlined
            hide-details
        ></v-select>
        </span>
        <span style="width:20px"/>
        <span v-if="IsDetailKey_List(selected_itemList[index])">
            <v-select
                v-model="selected_itemList_detail[index]"
                :items="GetDetailKeyModel(selected_itemList[index])"
                item-text="name"
                item-value="key"
                label="상세 타입"
                @change="Refresh_ItemInfo"
                outlined
                hide-details
            ></v-select>
        </span>
        <span v-else-if="(!IsDetailKey_List(selected_itemList[index]) && IsContainDetailKey(selected_itemList[index]))">
            <v-text-field
            label="상세 타입(작성형)"
            v-model="selected_itemList_detail[index]"
            value=""            
        ></v-text-field> 
        </span>
        <span style="width:20px"/>
        <span style="width:120px">
        <v-text-field
            label="지급보너스 (%)"
            v-model="selected_itemList_count[index]"
            value=""            
            type="number"
        ></v-text-field> 
        </span>
        <div style="width: 10px;"></div>
        <span style="width:120px">
        <v-text-field
            label="유지시간 (Sec)"
            v-model="selected_itemList_duration[index]"
            value=""            
            type="number"
        ></v-text-field> 
        </span>
         <div style="width: 10px;"></div>
        <span style="width:80px">
             <v-btn width="80px"  style="background-color: #b9fbc0; color: black;"  @click="Select_ItemSetTime(index ,86400)">하루</v-btn>
        </span>
         <div style="width: 10px;"></div>
        <span style="width:80px">
             <v-btn width="80px"  style="background-color: #6be585; color: black;"   @click="Select_ItemSetTime(index ,604800)">일주일</v-btn>
        </span>
         <div style="width: 10px;"></div>
        <span style="width:80px">
             <v-btn width="80px"  style="background-color: #2ecc71; color: black;"  @click="Select_ItemSetTime(index ,2592000)">한달</v-btn>
        </span>
        <span style="width:20px"/>        
        <span v-if="(selected_itemList.length -1 ) != index">        
            <v-btn 
            elevation="2"
            icon
            outlined
            @click=OnRemoveItem(index)
            >
                <v-icon dark>
                mdi-close
                </v-icon>
            </v-btn>
        </span>
        </v-list-item>   
        </template>
        <v-divider class="mt-6"/>

        <v-list-item class="mt-3">       
            <v-spacer></v-spacer>
            <v-btn width="120px"  color="lime accent-3"  @click="OnRegist_Coupon" :disabled="customSwitch?doubleCheck?true:false:false">쿠폰 생성하기</v-btn>
            <v-spacer></v-spacer>
        </v-list-item>       
        <!-- 지급 상품  -->
        <!-- 유효 기간  -->
        <!-- 등록 하기  -->



    </v-list>
    </v-card>

    <v-dialog
        v-model="loading_dialog"
        persistent
        width="300"
    >
        <v-card
        color="primary"
        dark
    >
        <v-card-text>
        당신의 서버는 일히는 중이다!
        <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
        ></v-progress-linear>
        </v-card-text>
    </v-card>
    </v-dialog>

    <v-card
        class="mx-auto mt-4"
        max-width="95%"
        elevation="2"
    >
    <v-toolbar
        color="#37474F"
        dark
    >
    <v-toolbar-title>쿠폰 발급 이력</v-toolbar-title>
    </v-toolbar>
    <v-list>
        <v-data-table         
        :footer-props="{'items-per-page-options':[20, 50, -1]}"
        :headers="headers" 
        :items="mail_history_all"
        :loading="loadingData"
        >        
        <template v-slot:item="row">            
            <tr>
            <td>{{row.item.COUPON_EXP}}</td>
            <td>{{row.item.CREATE_USER_ID}}</td>
            <td>{{row.item.CREATE_DT}}</td>
            <td>{{row.item.EXPIRE_DT}}</td>
            <td>{{row.item.COUPON_TYPE}}</td>
            <td>{{row.item.CREATE_COUNT}}</td>
            <td>{{row.item.USED_COUNT}}</td>
                    
                    
            <td>
                <!-- <v-btn class="mx-2" fab dark small color="indigo lighten-3" @click="OnDownloadCouponList(row.item.PID)"> -->
                <v-btn class="mx-2" fab dark small color="indigo lighten-3" @click="OnDownloadCouponList(row.item.PID)">
                    
                    <v-icon 
                    color= "light-blue accent-4"
                    >mdi-download</v-icon>
                </v-btn>
            </td>
            </tr>
        </template>
        </v-data-table>
    </v-list>
       <!-- <v-dialog
        v-model="loading_dialog"
        hide-overlay
        persistent
        width="300"
    > -->
    </v-card>
    <div class='py-12'/>
    <div class='py-12'/>
    <v-snackbar
      v-model="snackbar"
      :vertical="vertical"
    >
      {{ text }}
    </v-snackbar>

    </div>   
    
</template>

<script>

import { mapActions } from 'vuex';
import moment from 'moment'
import store from '../../store';
import config from '../../config/config';
import { format, parseISO } from 'date-fns'
export default {
    name: 'UserList',
        
    data: () => ({
        snackbar: false,
        text: '',
        vertical: true,
        customCouponId:{
            flag: true,
            id:''
        },
        doubleCheck:true,
        customSwitch:false,
        loading_dialog:false,
        loadingData:false,        
        selected_game:'',
        couponCount:'',
        couponMessage:'',
        date_begin: format(parseISO(new Date().toISOString()), 'yyyy-MM-dd'),
        date_end:format(parseISO(new Date().toISOString()), 'yyyy-MM-dd'),
        date_picker_1: false,
        date_picker_2: false,

        itemInfoList:[
            {
                name:'채굴기',
                key:'1000001',
            },
            {
                name:'AI친구',
                key:'1000002',
                detail_keys:[{name:'(GM)AI친구',key:'2000000'},
                            {name:'일론도지',key:'2000001'},
                            {name:'제갈페페',key:'2000002'},
                            {name:'이계인',key:'2000003'},
                            {name:'피에로',key:'2000004'},
                            {name:'김부장',key:'2000005'},
                            {name:'양손에횃불',key:'2000006'}
                            
                ]
            }            
        ],

        selectedCouponType:'single',
        couponType:[
            { name: '싱글타입 (1회성 쿠폰)', value: 'single' },
            { name: '전체타입 (모든 유저 중복없이 사용가능)', value: 'all' },            
        ],

        selected_itemList:[],   ///인덱스만 담기것지 나중에 전송할때는 한번 가공하도록 한다         
        selected_itemList_detail:[],
        selected_itemList_duration:[],
        selected_itemList_count:[],   
        title_type_items:[],    //타이틀 설정 하도록 
        
        headers: [            
            { text: '쿠폰 Info', value: 'title' },
            { text: '관리자', value: 'admin' },            
            { text: '등록 일자', value: 'regist_date' },            
            { text: '만료 일자', value: 'expire_date' },            
            { text: '쿠폰 타입', value: 'target' },
            { text: '발급 갯수', value: 'coupon_count' },
            { text: '사용 갯수', value: 'use_count' },            
            { text: '다운로드', value: 'download' },
        ],
        mail_history_all:[
            {  
                PID: 17,
                COUPON_EXP: "안녕하세요 테스트 쿠폰입니다.",
                COUPON_TYPE: "all",
                CREATE_USER_ID: "justin",
                CREATE_DT: "2021-11-30 06:10:21",                
                EXPIRE_DT: "2021-11-30 00:00:00",
                CREATE_COUNT: 5252,
                USED_COUNT: 0
            },
        ],
        current_reward_list:[],
    }),

    created()
    {
        //store.state.selected_game_package = this.selected_game
        //console.log("COUPON : "+store.state.selected_game_package);
        this.couponMessage = "이벤트 쿠폰 발급";
        this.couponCount = 1;
        this.date_end = moment().add(3,'M').format('yyyy-MM-DD');
        this.LoadServerInfo();
        this.Refresh_ItemInfo();        
        this.ReloadList();
    },

    methods:{
        ...mapActions([
            'CREATE_COUPON',//쿠폰 생성하기 
            'GET_RECENT_COUPONLIST', //가장 최근 등록한 쿠폰리스트 가져오기 
            'GET_COUPON_LIST',      //쿠폰아이템을 가져오도록 한다 
            'CHECK_DOUBLE_COUPON_ID'
        ]),
        clearDoubleCheck(){
            this.resetCouponInputState()
        },
        resetCouponInputState(){
            this.customCouponId = { flag: true, id: '' }
            this.doubleCheck = true
        },
        onCouponTypeChange(){
            this.resetCouponInputState()
            if (this.selectedCouponType === 'single') {
                this.customSwitch = false
            }
            this.Refresh_ItemInfo()
        },
        onCustomSwitchChange(){
            this.resetCouponInputState()
        },
        clickCheckDoubleBtn(){
            this.checkDouble()
        },
        async checkDouble(){

            const custom_coupon_id = this.customCouponId.id
            const result = await this.CHECK_DOUBLE_COUPON_ID({custom_coupon_id})
            this.doubleCheck = result.double;
            if(result.double){
                this.text = '이미 존재하는 쿠폰 아이디 입니다.'
                this.snackbar = true
            } else {
                this.text = '중복확인 되었습니다.'
                this.snackbar = true
                this.customCouponId.flag = false
            }
            console.log(result.double)
        },
        LoadServerInfo(){   
            //let packageName = this.$store.state.selected_game_package;
            fetch(this.serverState_URL)
                    .then(response => response.json())
                    .then(data => {
                        console.log("JSJS :  "+JSON.stringify(data));
                        ///this.itemInfoList = data.server_state.SERVICE_OPTION.item_opt;
                        this.current_reward_list = this.itemInfoList;
                    })
                    .catch(error => {
                        console.error('Error fetching server state:', error);
                    });


        },
        ReloadList()
        {
            this.GET_RECENT_COUPONLIST({})
                .then((body_data) => {
                console.log(body_data);
                this.mail_history_all = body_data.coupon_list;
            })
            .catch((err) => {
                this.error = err;
                console.log(err);
            })
        },
        OnClickUserInfo(_item)
        {
            this.loadingData = true;
            alert(_item.user_id + "의 정보를 확인합니다.");
            //let locateValue  = location.protocol +  "//"+location.host+'/story_eventedit?seq_event_new='+selectItem.seq_event_new;
            //window.location.href = locateValue;
        },
        OnClickUser_Mail(_item)
        {
            this.loadingData = false;
            alert(_item.user_id + "에게 메일을 보내려고합니다.");
        },
        IsActiveState(_item)
        {
            return _item.active_yn=="Y"?true:false;
        },
        OnRegist_Coupon()
        {
            //alert('쿠폰을 등록하려 합니다. 내용 확인 ㅇㅈ?');
            let coupon_item = this.Make_ItemResultInfo();
            let coupon_type = this.selectedCouponType;
            let coupon_exp = this.couponMessage;
            let count = this.couponCount;
            let expire_dt =   this.date_end + ' 23:59:59';
            let custom_coupon_id = this.customCouponId;
            if(count > 500000)
                count = 500000;

            if(coupon_type == 'all')
                count = 1;
            if(coupon_item == '' || coupon_exp == '')
            {
                alert('필수 정보 입력필요!');
                return ;
            }

            //coupon_item = JSON.stringify(coupon_item);
            //console.log("JS: " + packageName);
            console.log("JS: " + coupon_type);
            console.log("JS: " + coupon_item);
            console.log("JS: " + coupon_exp);
            console.log("JS: " + expire_dt);
            console.log("JS: " + count);

            this.loading_dialog = true;

            this.CREATE_COUPON({coupon_type , coupon_item,coupon_exp, expire_dt , count, custom_coupon_id })
                .then((body_data) => {
                console.log(body_data);
                alert("완료!");
                this.loading_dialog = false;
                //this.mail_history_all = body_data.coupon_list;
                this.ReloadList();
            })
            .catch((err) => {
                this.error = err;
                console.log(err);
            })
        },

        Refresh_ItemInfo()
        {//등록된 아이템 정보 + 1
            let tempContainer1 = [];
            let tempContainer2 = [];
            let tempContainer3 = [];
            for(let index=0; index < this.selected_itemList.length; index++)
            {
                let item1 = this.selected_itemList[index];
                if(item1!= null)
                {
                    tempContainer1.push(item1);
                    let item2 = this.selected_itemList_count[index];
                    tempContainer2.push(item2 == undefined?0:item2);          
                    let item3 = this.selected_itemList_duration[index];                                
                    tempContainer3.push(item3??(24*3600)); //기본값은 24시간으로 설정한다.          
                }
            }
            this.selected_itemList= [];
            this.selected_itemList_count= [];
            this.selected_itemList_duration= [];
            for(let index=0; index < tempContainer1.length; index++)
            {
                let item1 = tempContainer1[index];
                if(item1!= null)
                {
                    this.selected_itemList.push(item1);
                    this.selected_itemList_count.push(tempContainer2[index]);
                    this.selected_itemList_duration.push(tempContainer3[index]);
                }
            }   
            this.selected_itemList.length = tempContainer1.length + 1;
            this.selected_itemList_count.length = tempContainer1.length + 1;
        },
        OnRemoveItem(_index)
        {
            this.selected_itemList[_index] = undefined;
            this.Refresh_ItemInfo();
        },
        
        IsContainDetailKey(_itemKey)
        {
            if(_itemKey == undefined)
                return false; 
            for(let index = 0; index < this.itemInfoList.length ; index++)
            {
                let item = this.itemInfoList[index];
                if(item.key == _itemKey)
                {
                    const isExist = Object.keys(item).includes('detail_keys')
                    console.log(_itemKey  + "  " + isExist);
                    return isExist;
                }
                    
            }
            return false;
        },
        IsDetailKey_List(_itemKey)
        {
            if(_itemKey == undefined)
                return false; 
            for(let index = 0; index < this.itemInfoList.length ; index++)
            {
                let item = this.itemInfoList[index];
                if(item.key == _itemKey)
                {
                    const isExist = Object.keys(item).includes('detail_keys')
                    if(isExist)
                    {
                        if(item.detail_keys.length > 0)
                            return true;
                        else
                            return false;
                    }
                }
                    
            }
            return false;
        },


        GetDetailKeyModel(_selectedItem)
        {
            for(let index = 0; index < this.itemInfoList.length ; index++)
            {
                let item = this.itemInfoList[index];
                if(item.key == _selectedItem)
                    return item.detail_keys;
            }
            return {};
        },
        Make_ItemResultInfo()
        {
            // selected_itemList:[],   ///인덱스만 담기것지 나중에 전송할때는 한번 가공하도록 한다         
            // selected_itemList_detail:[],
            // selected_itemList_count:[],
            let resultValue=[];
            //selected_itemList
            console.log("1:"+this.selected_itemList);
            console.log("2:"+this.selected_itemList_detail);
            console.log("3:"+this.selected_itemList_count);
            for(let index = 0; index < this.selected_itemList.length ; index++)
            {
                let itemInfo = {};
                if(this.selected_itemList[index] != undefined)
                {
                    itemInfo['key'] = this.selected_itemList[index];
                    itemInfo['count'] = this.selected_itemList_count[index];
                    itemInfo['duration'] = this.selected_itemList_duration[index];
                    if(this.selected_itemList_detail[index] != undefined)
                        itemInfo['detail_key'] = this.selected_itemList_detail[index];
                    // else
                    //     itemInfo['detail_key'] = '';
                    resultValue.push(itemInfo);
                }
            }
            console.log("RESULT:"+JSON.stringify(resultValue));
            return resultValue;//우편으로 전달할 데이터를 만든다 0
        },
        OnDownloadCouponList(coupon_pid)
        {
            this.loading_dialog = true;

            this.GET_COUPON_LIST({coupon_pid})
                .then((body_data) => {
                this.loading_dialog = false;
                let coupon_list = body_data.coupon_list;
                let dataContainer = '';
                for(let i=0; i < coupon_list.length;i++)
                {
                    let stringValue= '';
                    if(coupon_list.lengh -1 != i)
                    {
                        stringValue = coupon_list[i].COUPON_ID+"\n";
                    }
                    else{
                        stringValue = coupon_list[i].COUPON_ID;
                    }
                    stringValue = stringValue.replace("\\n", "\n");
                    dataContainer += stringValue;
                }
                var blob = new Blob([dataContainer], { type: "octet/stream" });
                var link = document.createElement('a');
                link.href = window.URL.createObjectURL(blob);
                link.download = 'CouponFile.csv';
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
            })
            .catch((err) => {
                this.error = err;
                console.log(err);
            })
        },
        TestSave(test_pid)
        {
            let data =["king", "king2"];
            var blob = new Blob([data], { type: "octet/stream" });
            var link = document.createElement('a');
            link.href = window.URL.createObjectURL(blob);
            link.download = 'filename.xls';
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        },
        Select_ItemSetTime(index , time){
            //this.selected_itemList_duration[index]  = time;
            this.$set(this.selected_itemList_duration, index, time);    
            //this.$set(this.selected_itemList_duration, index, time); // 하루
        }

    },
    computed: {
        serverState_URL () {
            return config.serverState_URL_CPU;
        },
        isLive(){
            return config.isLive;
        },
        computedDateFormattedMomentjs_begin () {
            return this.date_begin ? moment(this.date_begin).format('YYYY-MM-DD') : ''
        },
        computedDateFormattedMomentjs_end () {
            return this.date_end ? moment(this.date_end).format('YYYY-MM-DD') : ''
        },  
    },
    components:{
    },
    watch :{
            '$store.state.selected_game_package': function() {
            console.log("WHAT IS THIS? " + this.$store.state.selected_game_package)
            this.LoadServerInfo();
            this.ReloadList();//변경되었으니 리스트를 리프레시 하도록 한다 
            this.selected_itemList = [];
            this.selected_itemList_detail = [];
            this.selected_itemList_count = [];
            this.Refresh_ItemInfo();
        },
            '$store.state.selected_game_server': function() {
            console.log("WHAT IS THIS? " + this.$store.state.selected_game_server)
            this.LoadServerInfo();
            this.ReloadList();//변경되었으니 리스트를 리프레시 하도록 한다 
            this.selected_itemList = [];
            this.selected_itemList_detail = [];
            this.selected_itemList_count = [];
            this.Refresh_ItemInfo();
        },

    }
};
</script>

<style scoped>
.label-col {
  width: 160px;
  flex-shrink: 0;
}
@media (max-width: 600px) {
  .v-list-item { flex-wrap: wrap; }
  .v-list-item > span { width: 100% !important; }
  .v-list-item .v-card__title { padding: 8px 0; }
}
</style>
